import React,{useState} from "react";
import { MDBInput } from "mdb-react-ui-kit";



import logo from "../../assets/img/logo.png";
import noperson from "../../assets/img/noperson.svg";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import { DELETE_GROUP,FETCH_GROUP } from "../../constants";

import NotificationAlert from "react-notification-alert";

import moment from "moment";

const GroupList = () => {

  const navigate = useHistory();

  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = React.useState(true);

  let lcObj = localStorage.getItem("user");
  let lclStrge = JSON.parse(lcObj);

  const [groupList, setGroupList] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [alert, setAlert] = React.useState(null);

  const[filterList,setFilterLst] = useState([]);





  React.useEffect(() => {
    viewGroupList(1);
    
  }, []);


  const viewGroupList = (pageNo) => {
    let lcObj = localStorage.getItem("user");
    let lclStrge = JSON.parse(lcObj);
    let clientid=lclStrge?.client;
    let user_id=lclStrge?.user_id;

    axios
      .get(`${FETCH_GROUP}?page=${pageNo}&id=${user_id}`)
      .then((response) => {
        setGroupList(response.data);
       // setGroupList({...response.data,numOfPages:2});
        setFilterLst(response.data)
        setCurrentPage(pageNo);
        setIsLoading(false)
      })
      .catch((error) => {
        console.log("????", error);
        setIsLoading(false)
      });
  };




  const deletegrp = async (id) => {
   
    await axios
      .post(DELETE_GROUP, { id:  id.toString()})
      .then((res) => {
       const  options = {
          place: "tr",
          message: "Deleted Successfully",
          type: "success",

          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
        viewGroupList(currentPage);
      setAlert(null)
      })
      .catch((err) => console.log("--err-", err));
  };

  const confirmdeletegrp = (id) =>{
    setAlert(<ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => deletegrp(id)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
          You want to remove user ?
      </ReactBSAlert>
      );
  }

  const filterData = (e) =>{
    let filter = e.target.value;

     let filterdata = filterList?.message.filter((item,index)=>{
      return (item?.name.toString().includes(filter)
    
      )})
     setGroupList({
      message: filterdata,
      numOfPages:filterList.num_of_pages
    })
    // console.log("--221--",a);
    }

   

  return (
    <>
     <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
      <div className="content pd-0">
      {alert}
        <Row>
          <Card className="mb-0">
            <NotificationAlert ref={notificationAlertRef} />
            <CardBody>
              <Col sm="12">
                <Row>
                  <Col sm="9">
                    <h4 className="mt-4 add-content" onClick={()=>{
                          navigate.push("/admin/groups/createGroup");
                        }}>
                      <Button
                        className="btn btn-icon btn-link-add btn-sm mr-2"
                        
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </Button>
                      Add Group
                    </h4>
                  </Col>
                  <Col md='3' sm="12" className="mt-4">
                    <MDBInput label="Search" type="text" onChange={(e)=>filterData(e)} />
                  
                  </Col>
                </Row>
              </Col>
              <Col sm="12" className="tableheightwf">
                <Row>
                  <Table responsive striped>
                    <thead>
                      <tr>
                      <th>S.no</th>
                        <th>Group</th>
                        <th>Action</th>

                      
                      </tr>
                    </thead>
                    <tbody>
                      {groupList?.message?.length>0?groupList?.message?.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{++index}</td>
                              <td>{item.name}</td>
                             
                              {/* <td >
                                {item.usertype == "3" ? (
                                  <Badge color="primary">Postpaid</Badge>
                                ) : (
                                  <>
                                   <Badge color="info">prepaid</Badge>
                                   
                                  <i style={{marginLeft:"10px",cursor:"pointer"}} onClick={()=>{setCountModal(true);setCountHistory({name:item.username})}}  class="tim-icons icon-pencil" ></i>
                                  </>
                                 
                                  
                                )}
                              </td> */}
                             
                              
                              <td>
                                <a to="" className="text-info mr-2">
                                  <i
                                    class="tim-icons icon-pencil"
                                    onClick={() =>  navigate.push("/admin/groups/creategroup",{  id: item.id } )}
                                  ></i>
                                </a>
                                <a
                                  to=""
                                  value={item}
                                  onClick={() =>confirmdeletegrp(item.id)}
                                  //onClick={() =>deletegrp(item.id)}
                                  className="text-warning ml-2"
                                >
                                  <i className="tim-icons icon-trash-simple"></i>
                                </a>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      }) :
                      <tr>
                            <td colSpan={3}>No Records Found</td>
                          </tr>
                      }
                
                    </tbody>
                  </Table>
                </Row>
              </Col>
            </CardBody>
            { groupList?.num_of_pages>1&&
        <div style={{padding:"8px",marginLeft:"auto"}}>
        <ResponsivePagination
      current={currentPage}
      total={groupList?.num_of_pages}
      onPageChange={(newPage )=>{viewGroupList(newPage)}}
    />
    </div>
}
          </Card>

         
         
        </Row>
      </div>
    </>
  );
};

export default GroupList;
